import mime from "mime";

const generateHtml = (nomeArquivo: string, fileUrl: string) => `
    <!DOCTYPE html>
    <html>
      <head>
        <title>${nomeArquivo}</title>
        <style>
          * {
            box-sizing: border-box;
            margin: 0;
            border: 0;
            padding: 0;
          }

          html, body {
            margin: 0;
            height: 100%;
            overflow: hidden;
          }

          .toolbar {
            width: 100%;
            height: 48px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            padding: 0 16px;
            background: #f5f5f5;
            border-bottom: 1px solid #ddd;
            font-family: Arial, sans-serif;
          }

          .download-button {
            padding: 8px 16px;
            background: #009C4E;
            color: #fff;
            text-decoration: none;
            border-radius: 4px;
          }

          iframe {
            width: 100%;
            height: calc(100% - 49px);
            border: none;
          }
        </style>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
      </head>

      <body>
        <div class="toolbar">
          <strong>${nomeArquivo}</strong>
          <a class="download-button" href="${fileUrl}" download="${nomeArquivo}">
            Baixar
          </a>
        </div>

        <iframe src="${fileUrl}"></iframe>
      </body>
    </html>
  `;

/**
 * Função que executa o fluxo de visualização de dados;
 * @param nomeArquivo É necessário que o nome do arquivo tenha extensão;
 * @param arquivo Base64 dos dados;
 */
export const openInBlankBase64File = async (nomeArquivo: string, arquivo: string): Promise<void> => new Promise((accept, reject) => {
  try {
    const mimeType = mime.getType(nomeArquivo);
    setTimeout(function () {
      if (mimeType) {
        const byteCharacters = atob(arquivo);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        const url = URL.createObjectURL(blob);
        window.open(url);

        accept();
      }
    }, 0);
  } catch (e: unknown) {
    reject(e);
  }
});

/**
 * openInBlobInBlank
 * @param nomeArquivo 
 * @param blob 
 * @returns 
 */
export const openInBlobInBlank = async (nomeArquivo: string, blob: Blob): Promise<void> => new Promise((accept, reject) => {
  try {
    const mimeType = mime.getType(nomeArquivo);
    setTimeout(function () {
      if (mimeType) {
        const mimeType = mime.getType(nomeArquivo) ?? blob.type;

        const visualizaveis = [
          "application/pdf",
          "image/png",
          "image/jpeg",
          "image/gif",
          "text/plain"
        ];

        const url = URL.createObjectURL(blob);

        if (mimeType && visualizaveis.includes(mimeType)) {
          const mimeType = mime.getType(nomeArquivo) ?? blob.type;
          const blobWithType = new Blob([blob], { type: mimeType });
          const fileUrl = URL.createObjectURL(blobWithType);
          const html = generateHtml(nomeArquivo, fileUrl);
          const htmlBlob = new Blob([html], { type: "text/html" });
          const htmlUrl = URL.createObjectURL(htmlBlob);

          window.open(htmlUrl, "_blank");
        } else {
          const a = document.createElement("a");
          a.href = url;
          a.download = nomeArquivo;
          a.click();
        }
        accept();
      }
    }, 0);
  } catch (e: unknown) {
    reject(e);
  }
});


